import { activeModule } from "../providers/active-module";
import { Theme as CoreTheme } from "./src/shared/theme";
import { Theme as FourTimeTheme } from "../4time/theme";
import { Theme as IrsKomTheme } from "../IrsKom/theme";
import { Theme as Parhato2Theme } from "../parhato2/theme";

const modulesTheme: Record<string, any> = {
  "4TIME": FourTimeTheme,
  IRSKOM: IrsKomTheme,
  PARHATO2: Parhato2Theme,
};

let Theme = CoreTheme;

const moduleName = activeModule;
if (modulesTheme[moduleName]) {
  Theme = { ...CoreTheme, ...modulesTheme[moduleName] };
}

export default Theme;
